import BaseModel from './BaseModel';

/** Class representing a cron task manual run parameter definition. */
class CronTaskRunParameter extends BaseModel {
    static TYPE_DATETIME = 'datetime';
    static TYPE_STRING   = 'string';
    static TYPE_BOOLEAN  = 'boolean';
    static TYPE_NUMBER   = 'number';

    static types() {
        return [
            CronTaskRunParameter.TYPE_DATETIME,
            CronTaskRunParameter.TYPE_STRING,
            CronTaskRunParameter.TYPE_BOOLEAN,
            CronTaskRunParameter.TYPE_NUMBER,
        ];
    }

    displayLabel() {
        return this.label || this.name;
    }
}

export default CronTaskRunParameter;
